module.exports = __webpack_public_path__ + "static/media/python.84a8426a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Portfolio/images/platforms/python.png
 ** module id = 230
 ** module chunks = 0
 **/